import { defineMessage } from 'react-intl';

const requiredMessage = defineMessage({ id: "bAUoRd", defaultMessage: [{ type: 1, value: "label" }, { type: 0, value: " is required" }] });

export { requiredMessage };
//# sourceMappingURL=messages.esm.js.map
